export default (context) => {
    let id =  document.getElementById('add-text-page__textarea');
    id.focus();
    context.pickColorsMarginBottom = 0;
    context.selectColorStatus = false
}